import { React, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import $ from "jquery";
import Cookies from "js-cookie";

import { useStateValue } from "state";

import * as Proton from "assets/javascript/proton";
import * as Account from "assets/javascript/account";

function OwnershipDisclosure() {
    const navigate = useNavigate();
    const [state, dispatch] = useStateValue();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);

    return (
        <section className="user-agreement container">
            <div className="page-title">Ownership Disclosure</div>

            <div className="intro">
                <div className="last-updated">Last updated March 13, 2025</div>

                <div className="pre">Storex Marketplace Ltd is owned by its shareholders.</div>

                <div className="pre">Registered in England and Wales.</div>

                <div className="pre">Company Number 12619609.</div>
            </div>
        </section>
    );
};

export default OwnershipDisclosure;
